import { spaceClient } from 'lib/axios'

const API_CITIES = '/api/app/v1/cities'

/**
 * 州一覧を返す
 * @param {string} countryCode 国コード
 * @returns
 */
export const getCities = (countryCode) =>
  spaceClient.get(`${API_CITIES}?country_code=${countryCode}`, {})
